import { render } from "./QuizPageOne.vue?vue&type=template&id=9596a5de"
import script from "./QuizPageOne.vue?vue&type=script&lang=js"
export * from "./QuizPageOne.vue?vue&type=script&lang=js"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__